/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProfileByIdQueryVariables = {
    id: string;
    canReadBalance: boolean;
};
export type ProfileByIdQueryResponse = {
    readonly node: ({
        readonly __typename: "Agent";
        readonly principal: {
            readonly primaryWallet: {
                readonly mobile: string;
                readonly name: string;
                readonly balance?: string | undefined;
                readonly ownerName: string | null;
                readonly supportNotes: {
                    readonly list: ReadonlyArray<{
                        readonly noteId: string;
                        readonly whenCreated: string;
                    }>;
                } | null;
                readonly user: {
                    readonly id: string;
                    readonly mobile: string | null;
                    readonly agentUser: {
                        readonly name: string;
                    } | null;
                    readonly merchant: {
                        readonly id: string;
                        readonly name: string;
                    } | null;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"UserInfoHeader_walletData">;
            } | null;
        };
    } | {
        readonly __typename: "Merchant";
        readonly maybePrincipal: {
            readonly primaryWallet: {
                readonly mobile: string;
                readonly name: string;
                readonly balance?: string | undefined;
                readonly ownerName: string | null;
                readonly supportNotes: {
                    readonly list: ReadonlyArray<{
                        readonly noteId: string;
                        readonly whenCreated: string;
                    }>;
                } | null;
                readonly user: {
                    readonly id: string;
                    readonly mobile: string | null;
                    readonly agentUser: {
                        readonly name: string;
                    } | null;
                    readonly merchant: {
                        readonly id: string;
                        readonly name: string;
                    } | null;
                } | null;
                readonly " $fragmentRefs": FragmentRefs<"UserInfoHeader_walletData">;
            } | null;
        };
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
};
export type ProfileByIdQuery = {
    readonly response: ProfileByIdQueryResponse;
    readonly variables: ProfileByIdQueryVariables;
};



/*
query ProfileByIdQuery(
  $id: ID!
  $canReadBalance: Boolean!
) {
  node(id: $id) {
    __typename
    ... on Agent {
      principal {
        primaryWallet {
          ...UserInfoHeader_walletData_2fyIQr
          mobile
          name
          balance @include(if: $canReadBalance)
          ownerName
          supportNotes {
            list {
              noteId
              whenCreated
            }
            id
          }
          user {
            id
            mobile
            agentUser {
              name
            }
            merchant {
              id
              name
            }
          }
          id
        }
        id
      }
    }
    ... on Merchant {
      maybePrincipal: principal {
        primaryWallet {
          ...UserInfoHeader_walletData_2fyIQr
          mobile
          name
          balance @include(if: $canReadBalance)
          ownerName
          supportNotes {
            list {
              noteId
              whenCreated
            }
            id
          }
          user {
            id
            mobile
            agentUser {
              name
            }
            merchant {
              id
              name
            }
          }
          id
        }
        id
      }
    }
    id
  }
}

fragment AgentDepositsBlockHistory_user on User {
  id
  historyOfAgentDepositsUnblocks {
    whenBlocked
    whenUnblocked
    blockedBy
    blockReason
    blockSubject
    unblockReason
    unblockedBy
  }
}

fragment AllowToRecoverPin_user on User {
  id
  inPinRecovery
  isPinResetRisky
  customerAppVersion {
    appType
    string
    isUpToDate
    appVersionCode
  }
}

fragment Banners_banners on Wallet {
  user {
    agentUser {
      agent {
        whenTerminated
        terminationReason
        whenMarkedForTermination
        whenTerminationExpected
        whenTerminationPayoutCompletionConfirmed
        id
      }
    }
    id
  }
}

fragment BlockFromAgentDeposits_user on User {
  id
  agentDepositsBlock {
    whenBlocked
    blockedBy
    blockReason
    id
  }
  ...AgentDepositsBlockHistory_user
}

fragment BlockUnblockDevice_user on User {
  id
  mobile
  devices {
    deviceId
    deviceName
    deviceModel
    blockHistory {
      whenBlocked
      blockedBy
      blockReason
      whenUnblocked
      unblockedBy
      unblockReason
      blockSubject
    }
    activeBlock {
      id
      blockReason
      blockedBy
      whenBlocked
      whenExpires
      requestToModifyBlockTickets {
        status
        whenOpened
      }
      ...RequestToModifyBlock_activeBlock
    }
  }
}

fragment BlockUnblockUser_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
  }
  activeLegalEntityBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
}

fragment CancelAllAtx_wallet on Wallet {
  name
  mobile
}

fragment DirectDepositBlockHistory_user on User {
  id
  narrativeDirectDepositBlockHistory {
    whatHappened
    whenHappened
    doneBy
    reason
  }
}

fragment EscalateToMerchantSupport_user on User {
  possibleMerchantIssueTypes {
    type
    displayName
  }
  merchant {
    ufid
    id
  }
}

fragment ForgetQr_user on User {
  id
  name
  needsNewPin
  primaryWallet {
    name
    id
  }
}

fragment LogoutAllUserSessions_user on User {
  id
}

fragment RenameWallet_wallet on Wallet {
  id
  name
  mobile
  user {
    name
    id
  }
}

fragment RequestToBlockUnblockUser_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    whenBlocked
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment RequestToModifyBlock_activeBlock on ActiveBlock {
  id
  requestToModifyBlockTickets {
    status
    whenOpened
  }
}

fragment RequestToUnblockFromAgentDeposits_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    whenBlocked
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment RequestToUnblockFromUsingMultipleDevices_wallet on Wallet {
  id
  mobile
  activeMobileBlock {
    whenBlocked
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    id
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
}

fragment ResetPin_wallet on Wallet {
  name
  user {
    id
    isPinResetRisky
  }
}

fragment SendUpdateAppLink_wallet on Wallet {
  mobile
  name
  id
}

fragment SendWithdrawalCode_wallet on Wallet {
  id
  mobile
  name
}

fragment SendWoyofalCode_wallet on Wallet {
  id
  mobile
  name
}

fragment ShowWithdrawalCodes_wallet on Wallet {
  id
  name
  mobile
  ...SendWithdrawalCode_wallet
}

fragment ShowWoyofalCodes_wallet on Wallet {
  id
  name
  mobile
  ...SendWoyofalCode_wallet
}

fragment UnblockFromAgentDeposits_user on User {
  id
  agentDepositsBlock {
    whenBlocked
    blockedBy
    blockReason
    id
  }
  ...AgentDepositsBlockHistory_user
}

fragment UnblockFromUsingMultipleDevices_user on User {
  id
  personalMultipleDevicesBlock {
    blockReason
    blockedBy
    whenBlocked
    whenExpires
    lockedDevice {
      deviceId
      deviceName
      deviceModel
    }
    id
  }
  agentMultipleDevicesBlock {
    blockReason
    blockedBy
    whenBlocked
    whenExpires
    lockedDevice {
      deviceId
      deviceName
      deviceModel
    }
    id
  }
  ...DirectDepositBlockHistory_user
}

fragment UnblockFromUsingQrCards_user on User {
  ...DirectDepositBlockHistory_user
  id
  qrCardBlock {
    whenBlocked
    blockedBy
    blockReason
    whenExpires
    id
  }
}

fragment UnblockUserFromDormancy_user on User {
  id
  dormancyBlock {
    whenBlocked
    blockedBy
    blockReason
    whenExpires
    id
  }
}

fragment UpdateBlock_activeBlock on ActiveBlock {
  id
  blockReason
}

fragment UserInfoHeader_walletData_2fyIQr on Wallet {
  id
  ...WalletUserBlocks_blockData
  ...Banners_banners
  name
  mobile
  whenTerminated
  reasonTerminated
  whoTerminated
  balance @include(if: $canReadBalance)
  amountPending @include(if: $canReadBalance)
  kycTier
  kybTier
  isTrader
  photoEditUrl
  documentStatus
  hasRejectedGovIds
  isRefundAbuser
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  activeMobileBlock {
    whenBlocked
    blockSubject
    requestToModifyBlockTickets {
      status
    }
    id
  }
  activeLegalEntityBlock {
    whenBlocked
    blockSubject
    requestToModifyBlockTickets {
      status
    }
    id
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  billPayProblems {
    whenOpened
    billType
    status
    transactionId
  }
  supportGroupLeadEscalations {
    whenOpened
    status
    clickupTaskId
  }
  merchantSupportEscalations {
    whenOpened
    status
    clickupTaskId
  }
  balanceLimitInfoV1 {
    max
  }
  inflowLimitInfoV1 {
    max
  }
  user {
    id
    name
    agentUser {
      isActive
    }
    merchantUser {
      isActive
    }
    promoter {
      canKioskSignup
    }
    customerAppVersion {
      appType
      string
      isUpToDate
    }
    hasQrCard
    customerOverdraftStatus
    qrCardBlock {
      whenBlocked
      id
    }
    personalMultipleDevicesBlock {
      whenBlocked
      id
    }
    agentMultipleDevicesBlock {
      whenBlocked
      id
    }
    agentDepositsBlock {
      whenBlocked
      id
    }
    needsIdPhotoConfirmation {
      legalName
    }
    userOnAgentGamingWatchlist {
      isOnList
      whenUpdated
    }
    userOnAgentGamingWhitelist {
      isOnList
      whenUpdated
    }
    inPinRecovery
    hasWeakPin
    elligibleToReceivePayPromo
    ...AllowToRecoverPin_user
    ...UnblockFromUsingQrCards_user
    ...UnblockFromUsingMultipleDevices_user
    ...BlockFromAgentDeposits_user
    ...UnblockFromAgentDeposits_user
    ...LogoutAllUserSessions_user
    ...ForgetQr_user
    ...EscalateToMerchantSupport_user
  }
  legalEntity {
    wallets(walletType: PERSONAL) {
      mobile
      user {
        agentUser {
          isActive
        }
        merchantUser {
          isActive
        }
        promoter {
          canKioskSignup
        }
        id
      }
      id
    }
  }
  ...ShowWithdrawalCodes_wallet
  ...ShowWoyofalCodes_wallet
  ...ResetPin_wallet
  ...SendUpdateAppLink_wallet
  ...SendWithdrawalCode_wallet
  ...SendWoyofalCode_wallet
  ...RenameWallet_wallet
  ...CancelAllAtx_wallet
  ...RequestToBlockUnblockUser_wallet
  ...RequestToUnblockFromAgentDeposits_wallet
  ...RequestToUnblockFromUsingMultipleDevices_wallet
  ...BlockUnblockUser_wallet
}

fragment WalletUserBlocks_blockData on Wallet {
  ...BlockUnblockUser_wallet
  ...RequestToBlockUnblockUser_wallet
  ...RequestToUnblockFromUsingMultipleDevices_wallet
  ...RequestToUnblockFromAgentDeposits_wallet
  id
  mobile
  activeMobileBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
    whenExpires
    requestToModifyBlockTickets {
      status
      whenOpened
    }
    ...RequestToModifyBlock_activeBlock
    ...UpdateBlock_activeBlock
  }
  activeLegalEntityBlock {
    id
    blockReason
    blockedBy
    whenBlocked
    blockSubject
    whenExpires
    requestToModifyBlockTickets {
      status
      whenOpened
    }
    ...RequestToModifyBlock_activeBlock
    ...UpdateBlock_activeBlock
  }
  tickets {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  blockHistory {
    whenBlocked
    blockedBy
    blockReason
    whenUnblocked
    unblockedBy
    unblockReason
    blockSubject
    whenExpires
  }
  user {
    ...UnblockFromUsingMultipleDevices_user
    ...UnblockFromUsingQrCards_user
    ...UnblockFromAgentDeposits_user
    ...UnblockUserFromDormancy_user
    ...BlockUnblockDevice_user
    id
    name
    mobile
    qrCardBlock {
      id
      blockReason
      blockedBy
      whenBlocked
      whenExpires
    }
    dormancyBlock {
      id
      blockReason
      blockedBy
      whenBlocked
      whenExpires
    }
    personalMultipleDevicesBlock {
      id
      blockReason
      blockedBy
      whenBlocked
      whenExpires
      lockedDevice {
        deviceId
        deviceName
        deviceModel
      }
      requestToModifyBlockTickets {
        status
        whenOpened
      }
    }
    agentMultipleDevicesBlock {
      id
      blockReason
      blockedBy
      whenBlocked
      whenExpires
      lockedDevice {
        deviceId
        deviceName
        deviceModel
      }
      requestToModifyBlockTickets {
        status
        whenOpened
      }
    }
    agentDepositsBlock {
      id
      blockReason
      blockedBy
      blockSubject
      whenBlocked
      whenExpires
      requestToModifyBlockTickets {
        status
        whenOpened
      }
      ...UpdateBlock_activeBlock
    }
    devices {
      deviceId
      deviceName
      deviceModel
      activeBlock {
        id
        blockReason
        blockedBy
        whenBlocked
        whenExpires
        requestToModifyBlockTickets {
          status
          whenOpened
        }
        ...RequestToModifyBlock_activeBlock
        ...UpdateBlock_activeBlock
      }
    }
  }
  legalEntity {
    wallets(walletType: PERSONAL) {
      mobile
      user {
        agentUser {
          isActive
        }
        merchantUser {
          isActive
        }
        promoter {
          canKioskSignup
        }
        id
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ownerName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SupportNote",
  "kind": "LinkedField",
  "name": "list",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "whenCreated",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Wallet",
    "kind": "LinkedField",
    "name": "primaryWallet",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SupportNotes",
        "kind": "LinkedField",
        "name": "supportNotes",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentUser",
            "kind": "LinkedField",
            "name": "agentUser",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Merchant",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "canReadBalance",
            "variableName": "canReadBalance"
          }
        ],
        "kind": "FragmentSpread",
        "name": "UserInfoHeader_walletData"
      },
      {
        "condition": "canReadBalance",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v9/*: any*/)
        ]
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockReason",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockedBy",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenBlocked",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockSubject",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenExpires",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketShortInfo",
  "kind": "LinkedField",
  "name": "requestToModifyBlockTickets",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  (v8/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenUnblocked",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unblockedBy",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unblockReason",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenResolved",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceModel",
  "storageKey": null
},
v27 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserDevice",
    "kind": "LinkedField",
    "name": "lockedDevice",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/)
    ],
    "storageKey": null
  },
  (v8/*: any*/),
  (v18/*: any*/)
],
v28 = [
  (v13/*: any*/),
  (v12/*: any*/),
  (v11/*: any*/),
  (v15/*: any*/),
  (v8/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenTerminated",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "MerchantUser",
  "kind": "LinkedField",
  "name": "merchantUser",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Promoter",
  "kind": "LinkedField",
  "name": "promoter",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canKioskSignup",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isOnList",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "whenUpdated",
    "storageKey": null
  }
],
v35 = [
  (v17/*: any*/),
  (v16/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clickupTaskId",
    "storageKey": null
  }
],
v36 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "max",
    "storageKey": null
  }
],
v37 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Wallet",
    "kind": "LinkedField",
    "name": "primaryWallet",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ActiveBlock",
        "kind": "LinkedField",
        "name": "activeMobileBlock",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ActiveBlock",
        "kind": "LinkedField",
        "name": "activeLegalEntityBlock",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Block",
        "kind": "LinkedField",
        "name": "blockHistory",
        "plural": true,
        "selections": [
          (v13/*: any*/),
          (v12/*: any*/),
          (v11/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketShortInfo",
        "kind": "LinkedField",
        "name": "tickets",
        "plural": true,
        "selections": [
          (v17/*: any*/),
          (v23/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slackMessageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ticketType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reference",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MultipleDevicesBlock",
            "kind": "LinkedField",
            "name": "personalMultipleDevicesBlock",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MultipleDevicesBlock",
            "kind": "LinkedField",
            "name": "agentMultipleDevicesBlock",
            "plural": false,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BlockHistoryEntry",
            "kind": "LinkedField",
            "name": "narrativeDirectDepositBlockHistory",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "whatHappened",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "whenHappened",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "doneBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveBlock",
            "kind": "LinkedField",
            "name": "qrCardBlock",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveBlock",
            "kind": "LinkedField",
            "name": "agentDepositsBlock",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v12/*: any*/),
              (v11/*: any*/),
              (v8/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Block",
            "kind": "LinkedField",
            "name": "historyOfAgentDepositsUnblocks",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v20/*: any*/),
              (v12/*: any*/),
              (v11/*: any*/),
              (v14/*: any*/),
              (v22/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveBlock",
            "kind": "LinkedField",
            "name": "dormancyBlock",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserDevice",
            "kind": "LinkedField",
            "name": "devices",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Block",
                "kind": "LinkedField",
                "name": "blockHistory",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v11/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActiveBlock",
                "kind": "LinkedField",
                "name": "activeBlock",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentUser",
            "kind": "LinkedField",
            "name": "agentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Agent",
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "terminationReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenMarkedForTermination",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenTerminationExpected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenTerminationPayoutCompletionConfirmed",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v30/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          (v33/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppVersion",
            "kind": "LinkedField",
            "name": "customerAppVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "string",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUpToDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appVersionCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasQrCard",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerOverdraftStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IdDocument",
            "kind": "LinkedField",
            "name": "needsIdPhotoConfirmation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "legalName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentGamingListEntry",
            "kind": "LinkedField",
            "name": "userOnAgentGamingWatchlist",
            "plural": false,
            "selections": (v34/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentGamingListEntry",
            "kind": "LinkedField",
            "name": "userOnAgentGamingWhitelist",
            "plural": false,
            "selections": (v34/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inPinRecovery",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasWeakPin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elligibleToReceivePayPromo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPinResetRisky",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsNewPin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Wallet",
            "kind": "LinkedField",
            "name": "primaryWallet",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MerchantIssueEntry",
            "kind": "LinkedField",
            "name": "possibleMerchantIssueTypes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Merchant",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ufid",
                "storageKey": null
              },
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LegalEntity",
        "kind": "LinkedField",
        "name": "legalEntity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "walletType",
                "value": "PERSONAL"
              }
            ],
            "concreteType": "Wallet",
            "kind": "LinkedField",
            "name": "wallets",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentUser",
                    "kind": "LinkedField",
                    "name": "agentUser",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": "wallets(walletType:\"PERSONAL\")"
          }
        ],
        "storageKey": null
      },
      (v5/*: any*/),
      (v29/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reasonTerminated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "whoTerminated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kycTier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kybTier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isTrader",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "photoEditUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documentStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasRejectedGovIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRefundAbuser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ScamReportTicket",
        "kind": "LinkedField",
        "name": "scamReports",
        "plural": true,
        "selections": [
          (v17/*: any*/),
          (v23/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transactionIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillPayProblemTicket",
        "kind": "LinkedField",
        "name": "billPayProblems",
        "plural": true,
        "selections": [
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billType",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transactionId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SupportGroupLeadEscalationTicket",
        "kind": "LinkedField",
        "name": "supportGroupLeadEscalations",
        "plural": true,
        "selections": (v35/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantSupportEscalationTicket",
        "kind": "LinkedField",
        "name": "merchantSupportEscalations",
        "plural": true,
        "selections": (v35/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LimitInfo",
        "kind": "LinkedField",
        "name": "balanceLimitInfoV1",
        "plural": false,
        "selections": (v36/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LimitInfo",
        "kind": "LinkedField",
        "name": "inflowLimitInfoV1",
        "plural": false,
        "selections": (v36/*: any*/),
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SupportNotes",
        "kind": "LinkedField",
        "name": "supportNotes",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "canReadBalance",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amountPending",
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  },
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "principal",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "maybePrincipal",
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "principal",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Merchant",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProfileByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "principal",
                "plural": false,
                "selections": (v37/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "maybePrincipal",
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "principal",
                "plural": false,
                "selections": (v37/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Merchant",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dfa01e01a79da69c3bdbac3c02e4465a",
    "id": null,
    "metadata": {},
    "name": "ProfileByIdQuery",
    "operationKind": "query",
    "text": "query ProfileByIdQuery(\n  $id: ID!\n  $canReadBalance: Boolean!\n) {\n  node(id: $id) {\n    __typename\n    ... on Agent {\n      principal {\n        primaryWallet {\n          ...UserInfoHeader_walletData_2fyIQr\n          mobile\n          name\n          balance @include(if: $canReadBalance)\n          ownerName\n          supportNotes {\n            list {\n              noteId\n              whenCreated\n            }\n            id\n          }\n          user {\n            id\n            mobile\n            agentUser {\n              name\n            }\n            merchant {\n              id\n              name\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n    ... on Merchant {\n      maybePrincipal: principal {\n        primaryWallet {\n          ...UserInfoHeader_walletData_2fyIQr\n          mobile\n          name\n          balance @include(if: $canReadBalance)\n          ownerName\n          supportNotes {\n            list {\n              noteId\n              whenCreated\n            }\n            id\n          }\n          user {\n            id\n            mobile\n            agentUser {\n              name\n            }\n            merchant {\n              id\n              name\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AgentDepositsBlockHistory_user on User {\n  id\n  historyOfAgentDepositsUnblocks {\n    whenBlocked\n    whenUnblocked\n    blockedBy\n    blockReason\n    blockSubject\n    unblockReason\n    unblockedBy\n  }\n}\n\nfragment AllowToRecoverPin_user on User {\n  id\n  inPinRecovery\n  isPinResetRisky\n  customerAppVersion {\n    appType\n    string\n    isUpToDate\n    appVersionCode\n  }\n}\n\nfragment Banners_banners on Wallet {\n  user {\n    agentUser {\n      agent {\n        whenTerminated\n        terminationReason\n        whenMarkedForTermination\n        whenTerminationExpected\n        whenTerminationPayoutCompletionConfirmed\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment BlockFromAgentDeposits_user on User {\n  id\n  agentDepositsBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    id\n  }\n  ...AgentDepositsBlockHistory_user\n}\n\nfragment BlockUnblockDevice_user on User {\n  id\n  mobile\n  devices {\n    deviceId\n    deviceName\n    deviceModel\n    blockHistory {\n      whenBlocked\n      blockedBy\n      blockReason\n      whenUnblocked\n      unblockedBy\n      unblockReason\n      blockSubject\n    }\n    activeBlock {\n      id\n      blockReason\n      blockedBy\n      whenBlocked\n      whenExpires\n      requestToModifyBlockTickets {\n        status\n        whenOpened\n      }\n      ...RequestToModifyBlock_activeBlock\n    }\n  }\n}\n\nfragment BlockUnblockUser_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n  }\n  activeLegalEntityBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n}\n\nfragment CancelAllAtx_wallet on Wallet {\n  name\n  mobile\n}\n\nfragment DirectDepositBlockHistory_user on User {\n  id\n  narrativeDirectDepositBlockHistory {\n    whatHappened\n    whenHappened\n    doneBy\n    reason\n  }\n}\n\nfragment EscalateToMerchantSupport_user on User {\n  possibleMerchantIssueTypes {\n    type\n    displayName\n  }\n  merchant {\n    ufid\n    id\n  }\n}\n\nfragment ForgetQr_user on User {\n  id\n  name\n  needsNewPin\n  primaryWallet {\n    name\n    id\n  }\n}\n\nfragment LogoutAllUserSessions_user on User {\n  id\n}\n\nfragment RenameWallet_wallet on Wallet {\n  id\n  name\n  mobile\n  user {\n    name\n    id\n  }\n}\n\nfragment RequestToBlockUnblockUser_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    whenBlocked\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment RequestToModifyBlock_activeBlock on ActiveBlock {\n  id\n  requestToModifyBlockTickets {\n    status\n    whenOpened\n  }\n}\n\nfragment RequestToUnblockFromAgentDeposits_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    whenBlocked\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment RequestToUnblockFromUsingMultipleDevices_wallet on Wallet {\n  id\n  mobile\n  activeMobileBlock {\n    whenBlocked\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    id\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n}\n\nfragment ResetPin_wallet on Wallet {\n  name\n  user {\n    id\n    isPinResetRisky\n  }\n}\n\nfragment SendUpdateAppLink_wallet on Wallet {\n  mobile\n  name\n  id\n}\n\nfragment SendWithdrawalCode_wallet on Wallet {\n  id\n  mobile\n  name\n}\n\nfragment SendWoyofalCode_wallet on Wallet {\n  id\n  mobile\n  name\n}\n\nfragment ShowWithdrawalCodes_wallet on Wallet {\n  id\n  name\n  mobile\n  ...SendWithdrawalCode_wallet\n}\n\nfragment ShowWoyofalCodes_wallet on Wallet {\n  id\n  name\n  mobile\n  ...SendWoyofalCode_wallet\n}\n\nfragment UnblockFromAgentDeposits_user on User {\n  id\n  agentDepositsBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    id\n  }\n  ...AgentDepositsBlockHistory_user\n}\n\nfragment UnblockFromUsingMultipleDevices_user on User {\n  id\n  personalMultipleDevicesBlock {\n    blockReason\n    blockedBy\n    whenBlocked\n    whenExpires\n    lockedDevice {\n      deviceId\n      deviceName\n      deviceModel\n    }\n    id\n  }\n  agentMultipleDevicesBlock {\n    blockReason\n    blockedBy\n    whenBlocked\n    whenExpires\n    lockedDevice {\n      deviceId\n      deviceName\n      deviceModel\n    }\n    id\n  }\n  ...DirectDepositBlockHistory_user\n}\n\nfragment UnblockFromUsingQrCards_user on User {\n  ...DirectDepositBlockHistory_user\n  id\n  qrCardBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenExpires\n    id\n  }\n}\n\nfragment UnblockUserFromDormancy_user on User {\n  id\n  dormancyBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenExpires\n    id\n  }\n}\n\nfragment UpdateBlock_activeBlock on ActiveBlock {\n  id\n  blockReason\n}\n\nfragment UserInfoHeader_walletData_2fyIQr on Wallet {\n  id\n  ...WalletUserBlocks_blockData\n  ...Banners_banners\n  name\n  mobile\n  whenTerminated\n  reasonTerminated\n  whoTerminated\n  balance @include(if: $canReadBalance)\n  amountPending @include(if: $canReadBalance)\n  kycTier\n  kybTier\n  isTrader\n  photoEditUrl\n  documentStatus\n  hasRejectedGovIds\n  isRefundAbuser\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  activeMobileBlock {\n    whenBlocked\n    blockSubject\n    requestToModifyBlockTickets {\n      status\n    }\n    id\n  }\n  activeLegalEntityBlock {\n    whenBlocked\n    blockSubject\n    requestToModifyBlockTickets {\n      status\n    }\n    id\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  billPayProblems {\n    whenOpened\n    billType\n    status\n    transactionId\n  }\n  supportGroupLeadEscalations {\n    whenOpened\n    status\n    clickupTaskId\n  }\n  merchantSupportEscalations {\n    whenOpened\n    status\n    clickupTaskId\n  }\n  balanceLimitInfoV1 {\n    max\n  }\n  inflowLimitInfoV1 {\n    max\n  }\n  user {\n    id\n    name\n    agentUser {\n      isActive\n    }\n    merchantUser {\n      isActive\n    }\n    promoter {\n      canKioskSignup\n    }\n    customerAppVersion {\n      appType\n      string\n      isUpToDate\n    }\n    hasQrCard\n    customerOverdraftStatus\n    qrCardBlock {\n      whenBlocked\n      id\n    }\n    personalMultipleDevicesBlock {\n      whenBlocked\n      id\n    }\n    agentMultipleDevicesBlock {\n      whenBlocked\n      id\n    }\n    agentDepositsBlock {\n      whenBlocked\n      id\n    }\n    needsIdPhotoConfirmation {\n      legalName\n    }\n    userOnAgentGamingWatchlist {\n      isOnList\n      whenUpdated\n    }\n    userOnAgentGamingWhitelist {\n      isOnList\n      whenUpdated\n    }\n    inPinRecovery\n    hasWeakPin\n    elligibleToReceivePayPromo\n    ...AllowToRecoverPin_user\n    ...UnblockFromUsingQrCards_user\n    ...UnblockFromUsingMultipleDevices_user\n    ...BlockFromAgentDeposits_user\n    ...UnblockFromAgentDeposits_user\n    ...LogoutAllUserSessions_user\n    ...ForgetQr_user\n    ...EscalateToMerchantSupport_user\n  }\n  legalEntity {\n    wallets(walletType: PERSONAL) {\n      mobile\n      user {\n        agentUser {\n          isActive\n        }\n        merchantUser {\n          isActive\n        }\n        promoter {\n          canKioskSignup\n        }\n        id\n      }\n      id\n    }\n  }\n  ...ShowWithdrawalCodes_wallet\n  ...ShowWoyofalCodes_wallet\n  ...ResetPin_wallet\n  ...SendUpdateAppLink_wallet\n  ...SendWithdrawalCode_wallet\n  ...SendWoyofalCode_wallet\n  ...RenameWallet_wallet\n  ...CancelAllAtx_wallet\n  ...RequestToBlockUnblockUser_wallet\n  ...RequestToUnblockFromAgentDeposits_wallet\n  ...RequestToUnblockFromUsingMultipleDevices_wallet\n  ...BlockUnblockUser_wallet\n}\n\nfragment WalletUserBlocks_blockData on Wallet {\n  ...BlockUnblockUser_wallet\n  ...RequestToBlockUnblockUser_wallet\n  ...RequestToUnblockFromUsingMultipleDevices_wallet\n  ...RequestToUnblockFromAgentDeposits_wallet\n  id\n  mobile\n  activeMobileBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n    whenExpires\n    requestToModifyBlockTickets {\n      status\n      whenOpened\n    }\n    ...RequestToModifyBlock_activeBlock\n    ...UpdateBlock_activeBlock\n  }\n  activeLegalEntityBlock {\n    id\n    blockReason\n    blockedBy\n    whenBlocked\n    blockSubject\n    whenExpires\n    requestToModifyBlockTickets {\n      status\n      whenOpened\n    }\n    ...RequestToModifyBlock_activeBlock\n    ...UpdateBlock_activeBlock\n  }\n  tickets {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  blockHistory {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenUnblocked\n    unblockedBy\n    unblockReason\n    blockSubject\n    whenExpires\n  }\n  user {\n    ...UnblockFromUsingMultipleDevices_user\n    ...UnblockFromUsingQrCards_user\n    ...UnblockFromAgentDeposits_user\n    ...UnblockUserFromDormancy_user\n    ...BlockUnblockDevice_user\n    id\n    name\n    mobile\n    qrCardBlock {\n      id\n      blockReason\n      blockedBy\n      whenBlocked\n      whenExpires\n    }\n    dormancyBlock {\n      id\n      blockReason\n      blockedBy\n      whenBlocked\n      whenExpires\n    }\n    personalMultipleDevicesBlock {\n      id\n      blockReason\n      blockedBy\n      whenBlocked\n      whenExpires\n      lockedDevice {\n        deviceId\n        deviceName\n        deviceModel\n      }\n      requestToModifyBlockTickets {\n        status\n        whenOpened\n      }\n    }\n    agentMultipleDevicesBlock {\n      id\n      blockReason\n      blockedBy\n      whenBlocked\n      whenExpires\n      lockedDevice {\n        deviceId\n        deviceName\n        deviceModel\n      }\n      requestToModifyBlockTickets {\n        status\n        whenOpened\n      }\n    }\n    agentDepositsBlock {\n      id\n      blockReason\n      blockedBy\n      blockSubject\n      whenBlocked\n      whenExpires\n      requestToModifyBlockTickets {\n        status\n        whenOpened\n      }\n      ...UpdateBlock_activeBlock\n    }\n    devices {\n      deviceId\n      deviceName\n      deviceModel\n      activeBlock {\n        id\n        blockReason\n        blockedBy\n        whenBlocked\n        whenExpires\n        requestToModifyBlockTickets {\n          status\n          whenOpened\n        }\n        ...RequestToModifyBlock_activeBlock\n        ...UpdateBlock_activeBlock\n      }\n    }\n  }\n  legalEntity {\n    wallets(walletType: PERSONAL) {\n      mobile\n      user {\n        agentUser {\n          isActive\n        }\n        merchantUser {\n          isActive\n        }\n        promoter {\n          canKioskSignup\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '1eca4b3dfcddddcecf6409cb751217c0';
export default node;
